import './index.css';

export const RadioButton = ({ label, value, onClick, disabled = false }) => {
  return (
    <div className={`radio-button-container ${disabled ? "radio-button-container-disabled" : ""}`}

      onClick={() => {
        if (disabled) return;
        if (onClick) {
          onClick(!value);
        }
      }}

    >
      <div className={`radio-button-container-radio-button ${value ? "radio-button-container-radio-button-selected" : ""}`} />
      {label && <span className={`radio-button-container-label`}>{label}</span>}
    </div>
  );
};